export enum ValidatorType {
  Pattern = 'pattern',
  MaxLength = 'maxLength',
  RequiredText = 'requiredText',
  RequiredSelect = 'requiredSelect',
  MaxSelections = 'maxSelections',
  IncorrectPassword = 'incorrectPassword',
  GdprConsentRequired = 'gdprConsentRequired',
  HiddenAnswerMissing = 'missingHiddenAnswer',
  ReceiptHasAlreadyBeenSent = 'receiptHasAlreadyBeenSent',
  InvalidEmailReceipt = 'invalidEmailReceipt',
  InvalidEmailCollect = 'invalidEmailCollect',
  EmptyEmailCollect = 'emptyEmailCollect',
  QuotaError = 'QuotaError',
  BackendError = 'BackendError',
}
